export const processData = (data, rowObj) => {
  const bodyData = data.map((row) => {
    if (row.id === rowObj.id) {
      row.key = rowObj.key;
      row.value = rowObj.value;
    }
    return row;
  });

  if (data[data.length - 1].id === rowObj.id) {
    let newId = rowObj.id + 1;
    let newRow = {
      id: newId,
      key: '',
      valueFrom: 'event',
      value: '',
      fieldType: '',
      isMultiSelect: false,
    };
    bodyData.push(newRow);
  }
  return bodyData;
};

export const getFilteredArray = (array) => {
  let filterArr = [];
  for (let i = 0; i < array.length; i++) {
    if (array[i].key && array[i].key != '') {
      filterArr.push(array[i]);
    }
  }
  return filterArr;
};

export const getFieldInfoByName = (name) => {
  let description = '';
  switch (name) {
    case 'collection':
      description = 'Select a collection which you want to update.';
      break;
    case 'updateFindBy':
      description = 'Choose any one option to identify the location of Collection item.';
      break;
    case 'updateFindByResponseKeyForValue':
    case 'storageCustomKey':
      description = 'Enter the JSON path of the Item Id Key';
      break;
    case 'successMessage':
      description = '(Optional) Enter custom success message.';
      break;
    case 'errorMessage':
      description = '(Optional) Enter custom error message.';
      break;
    case 'page':
      description = 'Select the page you want users to land on.';
      break;
    case 'updateEntityBy':
      description = 'Choose any one option to switch Collection (Browser Storage) item.';
      break;
    case 'userRefField':
      description = 'Choose User Field to add Parent Collection Item';
      break;
    case 'collectionRefFields':
      description = 'Choose Reference Field to add Parent Collection Item';
      break;
    case 'userRole':
      description = 'Choose User Role for User to created with';
      break;
    case 'dataLocation':
      description = 'Select where the data should come from for the conditional redirect.';
      break;
    case 'collectionPage':
      description = 'Select the Page or Snippet that is connected to a collection.';
      break;
    case 'dataLocationCollection':
      description = `Select the Collection associated with the data location you've chosen; this collection will be used to set up the rules for redirection.`;
      break;
    case 'collectionField':
      description =
        'Select the specific field from your collection that will determine the rules for redirection based on its values.';
      break;
    case 'sessionFieldName':
      description = `Enter the Field Name (also known as JSON key) that you want to use from the Browser Session. You'll use the value of this field to set up the rules for conditional redirection.`;
      break;
    case 'redirectUrl':
      description = 'Choose the page where you want users to go after they log in.';
      break;
    case 'enableLoginUser':
      description = 'Enable to Login with recently created user.';
      break;
    case 'modalDataLocation':
      description =
        'Select where you want to gather the data for defining the rules that control when a pop-up window or modal appears. This data can come from a collection or from your current browser session.';
      break;
    case 'modalDataLocationCollection':
      description = `Pick the collection that's connected to the data location you've selected. This collection will be used to set the rules for when the modal window should open.`;
      break;
    case 'modalCollectionField':
      description =
        'Select the specific field from your collection that will determine when the modal should open based on its values.';
      break;
    case 'modalSessionFieldName':
      description = `Enter the Field Name (also known as JSON key) that exists in the Browser Session. You can use the value of this field to set up the rules for when the modal should open conditionally.`;
      break;
    case 'modalCollectionPage':
      description = 'Select the Page or Snippet that is connected to a collection.';
      break;
    case 'confirmationMessage':
      description = '(Optional) A custom confirmation alert message to display on a popup.';
      break;
    case 'externalAPI':
      description = `Select a External API that previously you've created.`;
      break;
    default:
      break;
  }
  return description;
};

export const createActionSettingsSchema = (actionData, eventAction) => {
  let schema = {};
  actionData.args.forEach((args) => {
    const dbParameters = eventAction.parameters.find((param) => {
      return param.name === args.name;
    });
    if (dbParameters) {
      schema[args.name] = dbParameters ? dbParameters.value : '';
    } else {
      schema[args.name] = args.value || '';
    }
  });
  return schema;
};

export const extractParameters = (values, actionData) => {
  return Object.keys(values).map((value) => {
    const action = actionData.args.find((param) => param.name === value);
    return { name: value, value: values[value], type: action.type };
  });
};
